export const locales = {
  "en": "en",
  "tr": "tr"
};

export const initialLanguage = locales.en;

export const storeEncriptionKey = "W90lMliE0NHqvM6Mt9xW2en8TA6o9cBB";